import React from "react";

function FloatingContainer(props) {
  return (
    <div className="fixed bottom-0 right-0 z-10 md:p-20 md:py-10 py-2 shadow-2xl flex gap-2 bg-white md:bg-transparent w-full md:shadow-none md:w-auto justify-around">
      {props.children}
    </div>
  );
}

export default FloatingContainer;
